module.exports = __webpack_public_path__ + "img/PXL_20240718_004154728.21c17190.jpg";